import { render, staticRenderFns } from "./CreateGrayscale.vue?vue&type=template&id=3fb04c26&scoped=true&"
import script from "./CreateGrayscale.vue?vue&type=script&lang=ts&"
export * from "./CreateGrayscale.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGrayscale.vue?vue&type=style&index=0&id=3fb04c26&lang=scss&scoped=true&"
import style1 from "./CreateGrayscale.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb04c26",
  null
  
)

export default component.exports